module.exports = __webpack_public_path__ + "img/img.37c3ea6b.png";